import { IDeposit } from '@lombard.finance/sdk';
import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IOptimisticClaim {
  /**
   * Bitcoin transaction ID that was claimed
   */
  txId: string;
  /**
   * Timestamp when the claim was added
   */
  timestamp: number;
}

export interface IDashboardSlice {
  optimisticClaims: IOptimisticClaim[];
  mintingTransaction?: IDeposit;
  txHash?: string;
}

const initialState: IDashboardSlice = {
  optimisticClaims: [],
  mintingTransaction: undefined,
};

export const dashboardSlice = createSlice({
  name: 'lbtcDashboard',
  initialState,
  reducers: {
    addOptimisticClaim: (state, action: PayloadAction<IOptimisticClaim>) => {
      state.optimisticClaims = [...state.optimisticClaims, action.payload];
    },
    setOptimisticClaims: (state, action: PayloadAction<IOptimisticClaim[]>) => {
      state.optimisticClaims = action.payload;
    },
    setMintingTransaction: (
      state,
      action: PayloadAction<IDeposit | undefined>,
    ) => {
      state.mintingTransaction = action.payload;
    },
    setTxHash: (state, action: PayloadAction<string | undefined>) => {
      state.txHash = action.payload;
    },
  },
});

const selectDashboard = (state: { lbtcDashboard: IDashboardSlice }) =>
  state.lbtcDashboard;

export const selectOptimisticClaims = createSelector(
  selectDashboard,
  state => state.optimisticClaims,
);

export const selectMintingTransaction = createSelector(
  selectDashboard,
  state => state.mintingTransaction,
);

export const selectTxHash = createSelector(
  selectDashboard,
  state => state.txHash,
);

export const {
  addOptimisticClaim,
  setOptimisticClaims,
  setMintingTransaction,
  setTxHash,
} = dashboardSlice.actions;
